const esc = (v) => String(v ?? "").replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const eur = (n) => `${Number(n ?? 0).toFixed(2).replace(".", ",")} €`;
const day = (d) => (d ? new Date(d).toLocaleDateString("fr-FR") : "—");
const STATUS = { active: "Active", paused: "En pause", past_due: "Paiement refusé", canceled: "Arrêtée" };

function delivery(s) {
  const r = s.relay;
  if (r) return `<p><b>${esc(r.kind === "locker" ? "Locker" : "Point Relais")} n° ${esc(r.id)}</b></p><p>${esc(r.name)}</p><p>${esc(r.address)}</p><p>${esc(r.zip)} ${esc(r.city)}${r.country ? ` · ${esc(r.country)}` : ""}</p>`;
  const a = s.address || {};
  return `<p>${esc(a.address)}</p><p>${esc(a.zip)} ${esc(a.city)}${a.country ? ` · ${esc(a.country)}` : ""}</p>`;
}

function products(s) {
  if (s.plan === "reassort") return (s.items || []).map((i) => `<li>${esc(i.quantity)} × ${esc(i.name)}</li>`).join("");
  return (s.products || []).map((p) => `<li>${esc(p.name || p.slug)}</li>`).join("");
}

function sheet(s) {
  const a = s.address || {};
  return `<section class="sheet">
    <header><div class="brand">OZENTYA</div><div>Fiche abonnée · imprimée le ${esc(new Date().toLocaleDateString("fr-FR"))}</div></header>
    <h1>${esc(s.name || s.first_name)}</h1>
    <p class="status">${esc(s.plan_label)} · Statut : <b>${esc(STATUS[s.status] || s.status)}</b></p>
    <div class="grid">
      <div class="box"><h2>Cliente</h2><p><b>${esc(s.name)}</b></p><p>Tél. : ${esc(s.phone)}</p><p>Email : ${esc(s.email)}</p>
        <p>Adresse : ${esc(a.address)}, ${esc(a.zip)} ${esc(a.city)}${a.country ? ` · ${esc(a.country)}` : ""}</p></div>
      <div class="box"><h2>Livraison · ${esc(s.shipping_label || "")}</h2>${delivery(s)}</div>
    </div>
    <div class="box"><h2>Soins de l'abonnement</h2><ol>${products(s)}</ol></div>
    <div class="grid">
      <div class="box"><h2>Montants</h2><p>Soins : ${eur(s.price)}</p><p>Livraison : ${eur(s.shipping_cost)}</p><p class="big">Total : ${eur(s.monthly_total)} ${s.plan === "reassort" && s.interval > 1 ? `tous les ${esc(s.interval)} mois` : "/ mois"}</p></div>
      <div class="box"><h2>Suivi</h2><p>Abonnée depuis le : ${esc(day(s.created_at))}</p><p>Prochain prélèvement : ${esc(s.status === "active" ? day(s.next_billing_at) : "—")}</p><p>Colis déjà envoyés : ${esc(s.deliveries ?? 0)}</p>
        ${s.status === "canceled" ? `<p>Arrêtée le : ${esc(day(s.canceled_at))}${s.cancel_reason ? ` · ${esc(s.cancel_reason)}` : ""}</p>` : ""}</div>
    </div>
    <div class="check"><span>☐ Colis préparé</span><span>☐ Étiquette Mondial Relay / Colissimo</span><span>☐ Expédié le : ____ / ____ / ______</span></div>
  </section>`;
}

const CSS = `*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#141013;margin:0}
.sheet{padding:16mm;page-break-after:always}.sheet:last-child{page-break-after:auto}
header{display:flex;justify-content:space-between;align-items:center;border-bottom:2px solid #B8893A;padding-bottom:8px;font-size:12px;color:#5E544D}
.brand{font-family:Georgia,serif;letter-spacing:6px;font-size:18px;color:#4A1942}
h1{font-family:Georgia,serif;font-weight:normal;font-size:26px;margin:18px 0 4px}.status{margin:0 0 16px;font-size:13px;color:#5E544D}
.grid{display:grid;grid-template-columns:1fr 1fr;gap:12px}.box{border:1px solid #D9C8B3;border-radius:6px;padding:12px 14px;margin-bottom:12px}
h2{font-size:12px;text-transform:uppercase;letter-spacing:2px;color:#7A5418;margin:0 0 8px}p{margin:3px 0;font-size:14px}.big{font-size:16px;font-weight:bold}
ol{margin:0;padding-left:20px;font-size:15px;line-height:1.8}.check{display:flex;gap:24px;flex-wrap:wrap;margin-top:16px;font-size:14px}@page{size:A4;margin:0}`;

/** Ouvre une vue A4 blanche (une page par abonnée) et lance l'impression du navigateur. */
export function printSubscriptions(list) {
  const w = window.open("", "_blank");
  if (!w) return false;
  w.document.write(`<!doctype html><html lang="fr"><head><meta charset="utf-8"><title>Fiches abonnées Ozentya</title><style>${CSS}</style></head><body>${list.map(sheet).join("")}</body></html>`);
  w.document.close();
  w.focus();
  setTimeout(() => w.print(), 300);
  return true;
}
